import { render, staticRenderFns } from "./ReSearchCardStaffBigEdit.vue?vue&type=template&id=0091d35d&scoped=true"
import script from "./ReSearchCardStaffBigEdit.vue?vue&type=script&lang=js"
export * from "./ReSearchCardStaffBigEdit.vue?vue&type=script&lang=js"
import style0 from "./ReSearchCardStaffBigEdit.vue?vue&type=style&index=0&id=0091d35d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0091d35d",
  null
  
)

export default component.exports